export class DesignCafeError extends Error {
  constructor(message: string, public code: number) {
    super(message);
  }
}
